import { type PropsWithChildren } from "react";

import { AppShell, Container } from "@mantine/core";

import LayoutFooter from "@/components/Layout/LayoutFooter";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import { LAYOUT_HEADER_HEIGHT } from "@/configs/layout";

export const DefaultLayout = ({ children }: PropsWithChildren) => {
  return (
    <AppShell
      withBorder={false}
      header={{ height: LAYOUT_HEADER_HEIGHT }}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
    >
      <AppShell.Header>
        <LayoutHeader />
      </AppShell.Header>

      <AppShell.Main>
        <Container size="lg">{children}</Container>
      </AppShell.Main>

      <AppShell.Footer>
        <LayoutFooter />
      </AppShell.Footer>
    </AppShell>
  );
};

export default DefaultLayout;
